<div class="grid">
    <div class="col-12">
    </div>
    <div class="col-12">
        <span class="p-float-label size_cent">
            <input id={{enteteData.name}} [(ngModel)]="enteteData.name" value="enteteData.name" class="p-inputtext size_cent" pInputText type="text" autofocus>
            <label>{{'ReqName' | translate}}</label>
        </span>
    </div>
    <div class="col-12">
    </div>
    <div class="col-12">
        <div>{{'Visibility' | translate}}</div>
        <p-dropdown [options]="enteteData.listVisibility" [(ngModel)]="enteteData.visibility"  placeholder="{{'Sel_TQuer' | translate}}" [style]="{'width':'100%'}"></p-dropdown>
    </div>
    <div class="col-12">
        <div>{{'Desc' | translate}}</div>
        <textarea [(ngModel)]="enteteData.desc" rows="5" cols="57" pInputTextarea></textarea>
    </div>
</div>
